import * as Adhoc from "./adhoc";
import * as AI from "./ai";
import * as Billing from "./billing";
import * as Folders from "./folders";
import * as Jobs from "./jobs";
import * as Metadata from "./metadata";
import * as Midterms from "./midterms";
import * as Panels from "./panels";
import * as Sharing from "./sharing";
import * as Studies from "./studies";

export default {
  Adhoc,
  AI,
  Billing,
  Folders,
  Jobs,
  Metadata,
  Midterms,
  Panels,
  Sharing,
  Studies,
};
